/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validateFullName = (value) => {
  if (value == null || value === '') return true;

  const regex = /^[a-zA-ZáéíóúüñäëïöüÿàèìòùÀÈÌÒÙÁÉÍÓÚÝÄËÏÖÜ\s-]+\s[a-zA-ZáéíóúüñäëïöüÿàèìòùÀÈÌÒÙÁÉÍÓÚÝÄËÏÖÜ\s-]+$/;

  if (regex.test(value.trim())) {
    return true;
  }

  return 'Must enter first and last name.';
};



export default validateFullName;
